import React from 'react'

export default function CloseBlackIcon(props) {


    return (
        <>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.1639 16.3277C5.84749 16.6441 5.83242 17.2091 6.17143 17.5406C6.5029 17.872 7.06791 17.8645 7.38432 17.5481L11.9948 12.9301L16.6128 17.5481C16.9368 17.872 17.4943 17.872 17.8257 17.5406C18.1497 17.2016 18.1572 16.6516 17.8257 16.3277L13.2152 11.7097L17.8257 7.09916C18.1572 6.77522 18.1572 6.21775 17.8257 5.88627C17.4867 5.56233 16.9368 5.5548 16.6128 5.87874L11.9948 10.4968L7.38432 5.87874C7.06791 5.56233 6.49537 5.54727 6.17143 5.88627C5.83996 6.21775 5.84749 6.78276 6.1639 7.09916L10.7819 11.7097L6.1639 16.3277Z" fill="black" />
            </svg>

        </>
    )
}
